export const LOUNGE_MAX_MEMBERS = 4_000
export const LOUNGE_FULL_ERROR_CODE = 'LOUNGE_FULL'
